import type { FaireProductEntity } from "../../entity_types/product";

export const p_ayjb9nbzh8: FaireProductEntity = {
  token: "p_ayjb9nbzh8",
  type: "product",
  name: "de la Paz Graceland blend",
  brandToken: "b_cgzjcth7hb",
  brandName: "Four Barrel Coffee",
  imageUrl:
    "https://cdn.faire.com/fastly/2fc0f902b4cfab163c153e48a00b161e5f33cf861175c992a57f1aec68875700.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/00240da7659c660bf4f2e19866bcd7dc9b99384aab32ddefbc5573d37ea3454b.jpeg",
    "https://cdn.faire.com/fastly/ce7d786c2293450403f5bbb042ddd045844d2494727dc2ffe77faba9ebc795ac.jpeg",
    "https://cdn.faire.com/fastly/b65e31ad1ed828f6c78bfee1a606201dc05debffe69ea5adad702ee8781f3148.jpeg",
  ],
  priceDollars: 25,
  description:
    "Caramel, currant, tangerine\n\nThis versatile, go-anywhere blend hits the center of that eternal Venn diagram: big-bodied enough for espresso, articulate enough for a cup of brew. You can dress it up, or dress it down, like a sharp black sweater. Graceland gets along great with both nightclub bouncers and boyfriends' parents. Straight-ahead, but not simple—it's got layers upon layers. In short, red means go.",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:14.326Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
